import React from "react";
import DetailsFooter from "../components/DetailsFooter";
import DetailsHeader from "../components/DetailsHeader";
import UserDataDeletion from "../components/UserDataDeletion";
export default function UserDataDeletionPage() { return <><DetailsHeader/><UserDataDeletion/><DetailsFooter/></>; }
